// Backend tüm yanıtları { message, data, errorCode, error } zarfıyla döner
// (mobildeki BaseResponse). Bu yardımcılar zarfı açar ve hataları tek tip
// bir ApiError'a çevirir, böylece çağıran katman her zaman aynı şekli görür.

export class ApiError extends Error {
  constructor(message, { code = null, status = null } = {}) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
  }
}

// Makine-okunur hata kodu: eski uçlar `errorCode`, /v2 uçları `code` kullanır
// (bkz. src/FRONTEND_INTEGRATION.md §2). Hata ayrımı DAİMA bu koda göre yapılır,
// `error` metnine göre değil — metinler değişebilir, kodlar sözleşmedir.
const codeOf = (body) => body?.errorCode ?? body?.code ?? null;

// Başarılı axios yanıtının zarfını açar. Hata alanı doluysa ApiError fırlatır.
// Null alanlar serialize edilmediği için (§3) `error`/`errorCode` yalnızca
// gerçekten hata varken gövdede bulunur.
export const unwrap = (response) => {
  const body = response?.data ?? {};
  // Boş string'i hata sayma: bazı eski uçlar alanı null yerine '' ile döndürüyor.
  if (body.errorCode != null || (body.error != null && body.error !== '')) {
    throw new ApiError(body.error || body.message || 'İstek başarısız oldu', {
      code: codeOf(body),
      status: response?.status,
    });
  }
  return body.data;
};

// axios hatasını (network / 4xx / 5xx) okunabilir bir ApiError'a çevirir.
export const toApiError = (error) => {
  if (error instanceof ApiError) return error;

  const res = error.response;
  if (res) {
    const body = res.data || {};
    const message =
      body.error ||
      body.message ||
      `Sunucu hatası (${res.status})`;
    return new ApiError(message, { code: codeOf(body), status: res.status });
  }

  // Yanıt yok: ağ / timeout hatası.
  return new ApiError(
    'Sunucuya bağlanılamıyor. Lütfen internet bağlantınızı kontrol edin.',
    { status: null }
  );
};
